<template functional>
  <i
    :class="{
      'nx-bcube-logo--brand': props.brand,
      'nx-bcube-logo--only-icon': props.icon && !props.width && !props.height,
      'nx-bcube-logo--width': props.icon || props.width,
      'nx-bcube-logo--height': props.icon || props.height,
    }"
    :style="{width: props.width, height: props.height}"
    class="nx-bcube-logo"
  >
    <svg
      :viewBox="props.icon ? '0 0 50 60' : '0 0 192 60'"
      :width="props.icon ? 60 : 192"
      fill="none"
      height="60"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          v-if="!props.icon"
          :fill="props.color"
          d="M70.0807 13.8216H75.2922V22.8046C75.2922 23.8302 75.2085 24.5669 75.2085 24.5669H75.2922C75.2922 24.5669 77.1382 21.5321 81.5711 21.5321C87.2305 21.5321 90.8429 26.0027 90.8429 32.4867C90.8429 38.9707 86.7826 43.4412 81.2446 43.4412C76.8954 43.4412 75.0076 40.3227 75.0076 40.3227H74.9239C74.9239 40.3227 75.0076 40.9381 75.0076 41.7585V42.9473H70.0849V13.8216H70.0807ZM80.3363 39.0502C83.2078 39.0502 85.5854 36.7103 85.5854 32.5662C85.5854 28.4221 83.4506 26.0027 80.3739 26.0027C77.6656 26.0027 75.1248 27.9701 75.1248 32.6081C75.1248 35.848 76.8494 39.0502 80.3363 39.0502Z"
        />
        <path
          v-if="!props.icon"
          :fill="props.color"
          d="M108.847 13.3319C115.946 13.3319 119.596 17.3127 119.596 17.3127L117.051 21.2517C117.051 21.2517 113.727 18.175 109.094 18.175C102.94 18.175 99.3278 22.7711 99.3278 28.1835C99.3278 33.5959 103.062 38.6023 109.131 38.6023C114.175 38.6023 117.583 34.9103 117.583 34.9103L120.37 38.7237C120.37 38.7237 116.348 43.4412 108.926 43.4412C100.023 43.4412 93.8694 36.8358 93.8694 28.2631C93.8694 19.6903 100.27 13.3319 108.842 13.3319H108.847Z"
        />
        <path
          v-if="!props.icon"
          :fill="props.color"
          d="M123.778 22.026H128.989V34.4164C128.989 36.9614 129.646 38.6818 132.229 38.6818C136.005 38.6818 138.094 35.3582 138.094 31.6244V22.026H143.305V42.9473H138.299V40.5697C138.299 39.7493 138.382 39.0921 138.382 39.0921H138.299C137.273 41.2646 134.607 43.4412 131.036 43.4412C126.566 43.4412 123.774 41.185 123.774 35.4838V22.026H123.778Z"
        />
        <path
          v-if="!props.icon"
          :fill="props.color"
          d="M148.471 13.8216H153.682V22.8046C153.682 23.8302 153.598 24.5669 153.598 24.5669H153.682C153.682 24.5669 155.528 21.5321 159.961 21.5321C165.62 21.5321 169.233 26.0027 169.233 32.4867C169.233 38.9707 165.172 43.4412 159.634 43.4412C155.285 43.4412 153.397 40.3227 153.397 40.3227H153.314C153.314 40.3227 153.397 40.9381 153.397 41.7585V42.9473H148.475V13.8216H148.471ZM158.726 39.0502C161.598 39.0502 163.975 36.7103 163.975 32.5662C163.975 28.4221 161.84 26.0027 158.764 26.0027C156.055 26.0027 153.515 27.9701 153.515 32.6081C153.515 35.848 155.239 39.0502 158.726 39.0502Z"
        />
        <path
          v-if="!props.icon"
          :fill="props.color"
          d="M182.728 21.5363C188.76 21.5363 192 25.9273 192 31.4653C192 32.0806 191.879 33.4746 191.879 33.4746H177.437C177.764 37.1247 180.598 39.0125 183.712 39.0125C187.077 39.0125 189.744 36.7145 189.744 36.7145L191.753 40.4483C191.753 40.4483 188.555 43.4412 183.343 43.4412C176.412 43.4412 172.104 38.4349 172.104 32.4867C172.104 26.0445 176.495 21.5321 182.728 21.5321V21.5363ZM186.747 29.904C186.663 27.0743 184.901 25.5548 182.603 25.5548C179.936 25.5548 178.09 27.1957 177.596 29.904H186.747Z"
        />
        <path
          :fill="props.color"
          clip-rule="evenodd"
          d="M25.9318 1.12998L49.1428 14.5291C49.6451 14.818 50.0511 15.5212 50.0511 16.0989V42.9013C50.0511 43.4748 49.6409 44.1822 49.1428 44.4711L25.9318 57.8702C25.4337 58.159 24.6174 58.159 24.1193 57.8702L0.908346 44.4711C0.406035 44.1822 0 43.479 0 42.9013V16.0989C0 15.5254 0.410221 14.818 0.908346 14.5291L24.1193 1.12998C24.6174 0.841153 25.4337 0.841153 25.9318 1.12998ZM4.59196 42.6083L21.3482 33.0435C22.018 32.6626 22.2482 31.8086 21.8673 31.1389C21.4864 30.4691 20.6324 30.2389 19.9627 30.6198L3.20642 40.1847C2.53667 40.5656 2.30644 41.4195 2.68736 42.0893C2.94689 42.5413 3.41571 42.7925 3.90128 42.7925C4.13569 42.7925 4.37429 42.7339 4.59196 42.6083ZM46.5517 42.4367C46.8824 42.2441 47.1544 41.7753 47.1544 41.3902V17.2374C47.1544 16.8523 46.8824 16.3835 46.5517 16.1909L25.6304 4.11036C25.2955 3.91781 24.7514 3.91781 24.4207 4.11036L3.50362 16.1909C3.39897 16.2495 3.30269 16.3375 3.21898 16.4379C3.15619 16.5551 3.17712 16.7016 3.44502 16.8565C3.4492 16.8586 3.45339 16.8617 3.45757 16.8649C3.46176 16.868 3.46595 16.8712 3.47013 16.8732C3.48269 16.8774 3.49943 16.8858 3.49943 16.8858L24.4207 28.9664C24.7514 29.1589 25.0235 29.6278 25.0235 30.0129V53.0564V53.7052C25.0235 53.7052 25.0025 54.0526 25.3248 54.2619C25.5467 54.4043 25.7602 54.3959 25.9276 54.3457L46.5517 42.4367ZM27.9076 25.9985L42.3407 17.6685C43.0062 17.2834 43.8601 17.5136 44.2453 18.1792C44.6304 18.8447 44.4001 19.6987 43.7346 20.0838L29.3015 28.4138C29.0838 28.5435 28.8452 28.6021 28.6066 28.6021C28.1253 28.6021 27.6564 28.351 27.3969 27.9031C27.0118 27.2375 27.242 26.3836 27.9076 25.9985Z"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  </i>
</template>

<script>
export default {
  name: 'NxBcubeLogo',
  functional: true,
  props: {
    /**
     * If true, set the bCube's brand colors.
     * If true, `color` prop is ignored.
     */
    brand: Boolean,
    icon: Boolean,
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: String,
      default: undefined,
    },
    height: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style lang="stylus">
@import '../../assets/stylus/variables.styl'

i.nx-bcube-logo {
  font-size: 0;
  display: inline-block;

  &--brand {
    svg path {
      fill: $nx-brand--darken-1;

      &:last-of-type {
        fill: $nx-brand
      }
    }
  }

  &--only-icon {
    width: 24px;
    height: 24px;
  }

  &--width svg {
    width: 100%;
  }

  &--height svg {
    height: 100%;
  }
}
</style>
